"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultValidationResult = { isValid: true, reason: "" };
//# sourceMappingURL=IValidationResult.js.map